import React, {PureComponent} from 'react';
import {Card, CardBody, Col} from 'reactstrap';
import {Field, reduxForm} from 'redux-form';
import {withTranslation} from "react-i18next";

// import Collapse from '../../../shared/components/Collapse';

class Statistics extends PureComponent {

    render() {
        const {handleSubmit, blog, t} = this.props;

        return (
            <Col xs={12} md={12} lg={12} xl={12}>
                <Card>
                    <CardBody>
                        <div className="card__title">
                            <h5 className="bold-text">{t('settings.statistics.title')}</h5>
                        </div>
                        <form className="form form--horizontal" onSubmit={handleSubmit}>
                            <div className="form__form-group">
                                <span
                                    className="form__form-group-label">{t('settings.statistics.form_google_analytics.label')}:</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="analytics_gtag"
                                        component="input"
                                        type="text"
                                        placeholder="UA-xxxxxxxxx-x"
                                        value={blog.title}
                                    />
                                </div>
                            </div>
                            <div className="form__form-group">
                                <span
                                    className="form__form-group-label">{t('settings.statistics.form_webmaster_tools_code.label')}:</span>
                                <div className="form__form-group-field">
                                    <Field
                                        name="webmastertools_id"
                                        component="input"
                                        type="text"
                                    />
                                </div>
                            </div>
                        </form>
                    </CardBody>
                </Card>
            </Col>
        );
    }
}

export default reduxForm({
    form: 'blog_settings', // a unique identifier for this form
    enableReinitialize: true
})(withTranslation('dashboard')(Statistics));
